<template>
    <v-container fluid>
        <v-row >
            <v-col>
                <service-list :items="services" @serviceSelected="handleServiceSelected"/>
            </v-col>
        </v-row>
        <v-row  class="mt-3">
            <v-col>
                <v-btn color="success" @click="handleCreateServiceButtonClick">Create service</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import ServiceList from '../Components/ServiceList';
    import {mapGetters, mapActions, mapState} from 'vuex'

    export default {
        name: 'Services',
        components: {
            ServiceList
        },
        methods: {
            ...mapActions({
                getServices: 'services/getAll',
            }),
            handleCreateServiceButtonClick() {
                this.$router.push('services/create')
            },
            handleServiceSelected(serviceId) {
                this.$router.push({
                    path: `/services/${serviceId}`
                })
            }
        },
        computed: {
            ...mapState('services', {
                services: 'services'
            }),
            ...mapGetters('services', {
                progress: 'progress'
            })
        },
        created() {
            this.getServices()
        }
    }
</script>

<style scoped>

</style>